<div class="label-configuration-container"
     #container
     meeClickOutside
     (meeClickOutside)="onCloseLabelConfig()"
>
  <div class="input"
       (click)="isOpen=true"
       matTooltip="{{ 'configurations-fields.tooltips.LabelConfiguration' | translate}}">
    <div class="top-line">
      <div class="text">
        <span class="header"
              [ngClass]="{'opened':getResultText().length||isOpen,'focused':isOpen||isDoubleClick}">
          {{ 'configurations-fields.LabelConfiguration.Header' | translate}}
        </span>
        <span
          class="result">{{getResultText()}}</span>
      </div>
      <div class="mat-select-arrow" [ngClass]="{'opened':isOpen||isDoubleClick}"></div>
    </div>
    <div class="background-line" [ngClass]="{'opened':isOpen||isDoubleClick}">
      <div class="default-line"></div>
      <div class="blue-line"></div>
    </div>
  </div>
  <div class="object-label-container" [ngClass]="{'opened':isOpen}">
    <span class="header">
      {{ 'configurations-fields.LabelConfiguration.Title' | translate}}
    </span>
    <div class="checkbox-container">
      <mat-checkbox [color]="'primary'"
                    [checked]="inLabelConfig?inLabelConfig.ShowText:false"
                    (change)="changeResult($event, 'Text')">
        {{ 'configurations-fields.LabelConfiguration.Checkboxes.ShowText' | translate}}
      </mat-checkbox>
      <mat-checkbox [color]="'primary'"
                    [checked]="inLabelConfig?inLabelConfig.ShowRiser:false"
                    (change)="changeResult($event, 'Riser')">
        {{ 'configurations-fields.LabelConfiguration.Checkboxes.ShowRiser' | translate}}
      </mat-checkbox>
    </div>
    <mat-radio-group (change)="changeRadioButtonsGroupValue($event)"
                     [value]="inLabelConfig?inLabelConfig.LabelMarker:''">
      <mat-radio-button [color]="'primary'"
                        [value]="labelMarker.None">
        {{ 'configurations-fields.LabelConfiguration.RadioButtons.None' | translate}}
      </mat-radio-button>
      <mat-radio-button [color]="'primary'"
                        [value]="labelMarker.Triangle">
        {{ 'configurations-fields.LabelConfiguration.RadioButtons.Triangle' | translate}}
      </mat-radio-button>
      <mat-radio-button [color]="'primary'"
                        [value]="labelMarker.Pin">
        {{ 'configurations-fields.LabelConfiguration.RadioButtons.Pin' | translate}}
      </mat-radio-button>
      <mat-radio-button [color]="'primary'"
                        [value]="labelMarker.Point">
        {{ 'configurations-fields.LabelConfiguration.RadioButtons.Point' | translate}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>
